import './Banner.css'

function Banner() {
    //JSX
    return (
        <header className="banner">
            <img src="../images/banner.png" alt="O banner principal do site"/>
        </header>
    );
}

export default Banner